import { render, staticRenderFns } from "./RegionDetail.vue?vue&type=template&id=3a788275&"
import script from "./RegionDetail.vue?vue&type=script&lang=js&"
export * from "./RegionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports